// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/coge/associazioni-conti?societaId=',
    requestBody: null,
    response: '{ success: true, data: { associazioni: [{ tipoSoggetto, categoria, area, contoCogeId, conto }], sottocontiCliente: [{ id, codice, descrizione }], sottocontiFornitore: [{ id, codice, descrizione }] } }'
  },
  {
    method: 'PUT',
    endpoint: '/api/coge/associazioni-conti',
    requestBody: '{ societaId, tipoSoggetto, categoria, area, contoCogeId }',
    response: '{ success: true }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
